module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-928de46e3b7fdd4bc521f1fb2ca5db31.png";